@if (propertyViewModel?.securityAccess == null) {
  <nts-base-radio-button-text-box
    #baseRadioButtonTextBox
    (onChange)="onChange($event)"
    [tabIndex]="tabIndex"
    [showErrorTooltip]="showErrorTooltip"
    [showErrorBorder]="showErrorBorder"
    [hasError]="propertyViewModel.hasErrors"
    [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
    [isDisabled]="isDisabled || !(propertyViewModel.isEnabled$ | async) || propertyViewModel?.securityAccess != null"
    [label]="propertyViewModel.metadataDescription"
    [value]="value"
    (viewReady)="onBaseViewReady()"
    [options]="propertyViewModel.visibleValueDescriptions"
    [isNullable]="isNullable"
    [placeholder]="placeholder">
  </nts-base-radio-button-text-box>
} @else {
  <nts-base-security-text-box #baseSecurityTextBox [accessMode]="propertyViewModel.securityAccess"
    (viewReady)="onBaseViewReady()"
  [value]="initialValue != null ? initialValue : propertyViewModel.formattedValue$ | async"></nts-base-security-text-box>
}


